export default __webpack_public_path__ + "static/media/website.36a12299.mp4";